import type { FC } from "react";

import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { AntCustomFormField } from "../../types/types";
import { IdGenerator } from "../IdGenerator/IdGenerator";

export interface InputGeneratorProps extends AntCustomFormField<string> {
    label: string;
    readOnly: boolean;
    name: string;
    siteId: number;
    terminalProfileId: number;
}

export const TerminalIdGenerator: FC<InputGeneratorProps> = ({ siteId, terminalProfileId, ...restProps }) => {
    const fetchUrl = `/${ResourceName.TERMINAL_ID_GENERATOR}?siteId=${siteId}&terminalProfileId=${terminalProfileId}`;

    return <IdGenerator fetchUrl={fetchUrl} buttonName="terminalIdGenerator_button" {...restProps} />;
};
